import { Box, LinearProgress, Tooltip, Typography } from '@mui/material';

interface SlotsCellProps {
  inUse: number;
  budget: number | null;
}

export default function SlotsCell({ inUse, budget }: SlotsCellProps) {
  if (budget == null) {
    return (
      <Tooltip title={`${inUse} slots in use. This node has no slot limit.`}>
        <span>{inUse}</span>
      </Tooltip>
    );
  }
  const ratio = budget > 0 ? inUse / budget : inUse > 0 ? Number.POSITIVE_INFINITY : 0;
  const color = ratio > 1 ? 'error' : ratio >= 0.9 ? 'warning' : 'success';
  return (
    <Tooltip
      title={`${inUse} of ${budget} slots in use. This node is limited to ${budget} slots; workers cannot be started or grown past that.`}
    >
      <Box sx={{ minWidth: 96 }}>
        <Typography variant="body2" component="div" color={ratio > 1 ? 'error' : undefined}>
          {`${inUse} / ${budget}`}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={Math.min(ratio, 1) * 100}
          color={color}
          aria-label={`${inUse} of ${budget} slots`}
          sx={{ height: 6, borderRadius: 3 }}
        />
      </Box>
    </Tooltip>
  );
}
